import { Component, OnInit } from '@angular/core';
import { SuggestedDates } from '../../assets/interfaces/suggestedDates-Interface';
import { CurrentDog } from '../../assets/interfaces/mainTracker';
import { CurrentDayService } from '../services/current-day.service';
import { threadId } from 'worker_threads';
import { PaymentInfo } from 'src/assets/interfaces/paymentInfo';

@Component({
  selector: 'app-main-view',
  templateUrl: './main-view.component.html',
  styleUrls: ['./main-view.component.scss']
})
export class MainViewComponent implements OnInit {
  curDate = new Date();
  suggDates: SuggestedDates[] = [
    {SUGG_NUM: 4, SUGG_DATE: new Date(this.curDate.setDate(this.curDate.getDate() + 28)).toLocaleDateString()},
    {SUGG_NUM: 5, SUGG_DATE: new Date(this.curDate.setDate(this.curDate.getDate() + 7)).toLocaleDateString()},
    {SUGG_NUM: 6, SUGG_DATE: new Date(this.curDate.setDate(this.curDate.getDate() + 7)).toLocaleDateString()},
    {SUGG_NUM: 7, SUGG_DATE: new Date(this.curDate.setDate(this.curDate.getDate() + 7)).toLocaleDateString()},
    {SUGG_NUM: 8, SUGG_DATE: new Date(this.curDate.setDate(this.curDate.getDate() + 7)).toLocaleDateString()},
    {SUGG_NUM: 10, SUGG_DATE: new Date(this.curDate.setDate(this.curDate.getDate() + 14)).toLocaleDateString()}
  ];

  infoBox = '';

  dogName: string;
  lastName: string;
  phone: string;
  service = '';
  dogNotes: string;
  id: number;
  totalDue: number;
  totalPaid: number;
  payType = '';
  mainButton = 'Add Dog';
  totalDogs = 0;

  showCheckout: number;
  showOptions: number;

  inProgress: CurrentDog[] = [];
  completedDogs: CurrentDog[] = [];
  addedDog: CurrentDog;

  payInfo: PaymentInfo;

  constructor( private curDayServ: CurrentDayService ) { }

  ngOnInit(): void {
    // Check for a valid local version, not expired. This is something to verify....do we need a new date?

    if (new Date(localStorage.getItem('listExpire')).getDate() === new Date().getDate()){
      this.inProgress = JSON.parse(localStorage.getItem('inProgress'));
      this.completedDogs = JSON.parse(localStorage.getItem('completedDogs'));
      this.getDogCount();
      this.sortStatus();
    }else{
      this.inProgress = [];
      this.completedDogs = [];
    }

    if (this.inProgress === null){
      this.inProgress = [];
    }

    if (this.completedDogs === null){
      this.completedDogs = [];
    }

    if (this.inProgress.length === 0){
      this.getInProgFromDB();
    }

  }

  editDogInProgress(id: number){
    this.inProgress.forEach(el => {
      if (el.UNIQUE_ID == id) {
          this.dogName = el.NAME.substring(0, el.NAME.indexOf(' '));
          this.lastName = el.NAME.substring(el.NAME.indexOf(' '), el.NAME.length);
          this.phone = el.PHONE;
          this.dogNotes = el.NOTES;
          this.service = el.SERVICE;
          this.id = el.UNIQUE_ID;
          this.totalDue = el.TOTALDUE;
          this.mainButton = 'Update Dog';
      }
    });
  }

  getInProgFromDB(){
    this.curDayServ.getInProgFromDB()
      .subscribe(
        res => {
          this.inProgress = res;
          // Anything else here?
        },
        error => {
          console.log('Error:' + error);
          this.infoBox = 'Error Retrieving List from Database.';
        }, // If it errors, tell me.
        () => {
          this.infoBox = 'Local list not found, updated from database.';
          this.sortStatus();
          this.updateLocalStorage();
        } // Execute when complete
      );
  }

  // adds a new dog to the inprogress list
  addOrUpdateInProgress(){
    if (this.dogName == null || this.lastName == null || this.phone == null || this.service === ''){
      this.infoBox = 'All fields except for Notes are required.  Please fill everything out correctly before adding.';
      setTimeout(() => { this.infoBox = ''; }, 2000);
    }else if (this.phone.replace(/\D+/g, '').length !== 10){
      this.infoBox = 'Phone should be be in the format ###-###-####.  All 10 digits are required.';
      alert(this.phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'));
      setTimeout(() => { this.infoBox = ''; }, 2000);
    } else {
      // build the dog to add
      const name = this.dogName + ' ' + this.lastName;
      const newDog = {
        NAME: this.dogName + ' ' + this.lastName,
        STATUS: 1,
        PHONE: this.phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'),
        SERVICE: this.service,
        TIME: new Date().toLocaleTimeString('en-US'),
        ID: this.id,
        STEP: 0,
        VISIBLE: true,
        NOTES: this.dogNotes,
        TOTALDUE: this.totalDue
      };

      if (this.mainButton === 'Update Dog'){
        // Update the dogs info
        this.postUpdateDog(this.id, 'EDIT', newDog);
      } else {
        // insert into DB list
        this.postDog(newDog);
      }
    }
  }

  // Hides the dog in progress list. Doesn't really remove it, just hides.
  removeDog(id: number){
    this.inProgress.forEach(el => {
      if (el.UNIQUE_ID === id){
        el.VISIBLE = false;
      }
    });
  }

  copyDogDetails(id: number){
    let dogInfo = '';
    let i = 0;
    while (dogInfo === '' && i < 500){
      if (this.inProgress[i].UNIQUE_ID === id){
        dogInfo = this.inProgress[i].NAME + ' - ' + this.inProgress[i].PHONE + ' - ' + this.inProgress[i].SERVICE;
      }
      ++i;
    }

    navigator.clipboard.writeText(dogInfo).then(() => {
      console.log('Copied Successfully!');
    },
    () => {
      console.log('Copy Failed!');
    });
  }

  // This executes POST to add dog to DB
  postDog(newDog: CurrentDog){
    this.infoBox = 'Adding Dog to List...';

    this.curDayServ.postNewDog(newDog)
      .subscribe(
        res => {
          this.addedDog = res;
          // Anything else here?
        },
        error => {
          console.log('Error:' + error);
          this.infoBox = 'Dog was not added to DB Successfully. Adding to Local List';
          this.addToLocalInProgress(newDog);
        }, // If it errors, tell me.
        () => {
          if (newDog.NAME === 'ERROR'){
            this.infoBox = 'There was an issue updating the Database.';
          } else {
            this.infoBox = 'Adjusted in the Database.';
            this.addToLocalInProgress(this.addedDog);
          }
          
        } // Execute when complete
      );
  }

  // Update an existing dog in the database 
  postUpdateDog(id: number, typeOfUpdate: string, updateDog?: CurrentDog){
    let confirmed = true;
    let newDog: CurrentDog; 
    let addPayInfo = false;

    newDog = {
      NAME: 'UPDATE',
      STATUS: 1,
      PHONE: '',
      SERVICE: '',
      TIME: '',
      ID: Number(id),
      UNIQUE_ID: Number(id),
      STEP: 0,
      VISIBLE: true,
      NOTES: typeOfUpdate,
      TOTALDUE: 0,
      TOTALPAID: 0,
      PAYMENTTYPE: ''
    };

    // What type of update?  Send correct info
    if (typeOfUpdate === 'STEP') {
      newDog.STEP = Number(this.figureOutNextStep(id));
    } else if (typeOfUpdate === 'CHECKOUT_UNDO') {
      newDog.STATUS = 1;
      newDog.VISIBLE = true;
    } else if (typeOfUpdate === 'VISIBLE') {
      confirmed = confirm('Are you sure you want to remove this dog from the list?');
      newDog.VISIBLE = false;
    } else if (typeOfUpdate === 'EDIT'){
      newDog = updateDog;
    } else if (typeOfUpdate === 'CHECKOUT') {
      if (this.totalPaid <= 0 || this.payType === null){
        confirmed = false;
        this.infoBox = 'Please fill in the total paid and pay type before checking the dog out.';
        setTimeout( () => { this.infoBox = ''} , 5000);
      } else {
        newDog.STATUS = 2;
        newDog.VISIBLE = false;
        newDog.TOTALDUE = this.inProgress[this.inProgress.findIndex(el => el.UNIQUE_ID === id)].TOTALDUE;
        newDog.TOTALPAID = this.totalPaid;
        newDog.PAYMENTTYPE = this.payType;
        addPayInfo = true;
      }
    }

    if (confirmed){
      this.infoBox = 'Updating Dog...';
      this.curDayServ.postUpdateDog(newDog)
        .subscribe(
          res => {
            this.addedDog = res;
            // Anything else here?
          },
          error => {
            console.log('Error:' + error);
            this.infoBox = 'Dog was not updated in DB Successfully. Updating Local List';
            // add code to update local
          }, // If it errors, tell me.
          () => {
            this.infoBox = 'Adjusted in the Database.';
            // Add to adjust locally.
            this.updateDogLocally(id, typeOfUpdate, newDog.STEP);
            if (addPayInfo){
              this.payInfo = {
                DOG_ID: newDog.UNIQUE_ID,
                PAY_TYPE: newDog.PAYMENTTYPE,
                TOTAL_DUE: newDog.TOTALDUE,
                TOTAL_PAID: newDog.TOTALPAID
              };
              this.postPaymentInformation(this.payInfo);
            }
          } // Execute when complete
        );
    }
  }

  postPaymentInformation(payInfo: PaymentInfo){
    this.curDayServ.postPayment(payInfo)
    .subscribe(
      res => {
        this.payInfo = res;
        // Anything else here?
      },
      error => {
        console.log('Error:' + error);
        this.infoBox = 'Payment was not successfully entered.';
        // add code to update local
      }, // If it errors, tell me.
      () => {
        this.infoBox = 'Dog Successfully Checked Out.';
        // should we do something here? Sum it up? 
      } // Execute when complete
    );
  }

  // After updating in DB, Update local version.
  updateDogLocally(id: number, typeOfUpdate: string, step?: number){
    // Loop to find the right one, and edit it appropriately
    this.inProgress.forEach(el => {
      if (el.UNIQUE_ID === id) {
        if (typeOfUpdate === 'STEP') {
          el.STEP = step;
        } else if (typeOfUpdate === 'CHECKOUT') {
          el.STATUS = 2;
          el.TOTALPAID = this.totalPaid;
          el.PAYMENTTYPE = this.payType;
        } else if (typeOfUpdate === 'CHECKOUT_UNDO') {
          el.STATUS = 1;
          el.VISIBLE = true;
          this.completedDogs.splice(this.completedDogs.indexOf(el), 1);
        } else if (typeOfUpdate === 'VISBLE') {
          el.VISIBLE = false;
        } else if (typeOfUpdate === 'EDIT'){
          el.NAME = this.dogName + ' ' + this.lastName;
          el.PHONE = this.phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
          el.NOTES = this.dogNotes;
          el.SERVICE = this.service;
          el.TOTALDUE = this.totalDue;
        }
      }
    });

    this.sortStatus();
    this.updateLocalStorage();
    this.clearInputBoxes();
    this.mainButton = 'Add Dog';
  }

  // Cycles through the steps...Will go back to start once you get to end.
  figureOutNextStep(id: number){
    let newStep = 0;
    let curStep = 0;
    this.inProgress.forEach(el => {
      if (el.UNIQUE_ID === id){
        curStep = el.STEP;
      }
    });

    if (curStep < 3){
      newStep = curStep + 1;
    } else {
      newStep = 0;
    }

    return newStep;
  }

  addToLocalInProgress(dog: CurrentDog){
    // add it to the list and update the local storage version
    if (dog.NAME !== 'ERROR'){
      this.inProgress.push(dog);
      this.updateLocalStorage();
      // clear the inputs for next entry
      this.clearInputBoxes();
      this.infoBox = '';
    }
  }

  getDogCount(){
    this.totalDogs = 0;
    this.inProgress.forEach(el => {
      if (Boolean(el.VISIBLE) === true){
        this.totalDogs++;
      }
    });
  }

  showOptionButtons(id?: number) {
    this.showOptions = id;
    if (id != this.id){
      this.mainButton = 'Add Dog';
      this.clearInputBoxes();
      this.showCheckout = null;
    }
  }

  showCheckoutSection(id?: number){
    this.id = id;
    this.showCheckout = id;
  }

  clearInputBoxes(){
    this.dogName = null;
    this.lastName = null;
    this.phone = null;
    this.service = null;
    this.dogNotes = null;
    this.totalDue = null;
  }

  updateLocalStorage(){
    localStorage.setItem('inProgress', JSON.stringify(this.inProgress));
    localStorage.setItem('completedDogs', JSON.stringify(this.completedDogs));
    if (localStorage.getItem('listExpire') == null){
      localStorage.setItem('listExpire', new Date().toString());
    }
    if (localStorage.getItem('listExpire') != null){
      this.getDogCount();
    } else {
      setTimeout(() => { this.getDogCount(); }, 1000);
    }
  }

  sortStatus() {
    this.inProgress.forEach(el => {
      if (el.STATUS === 2 && el.VISIBLE) {
        el.VISIBLE = false;
        this.completedDogs.push(el);
      }
    });
  }
}
